// Dynamic date restriction rules for Premium Visa Solutions.
// Rule 1 — Intended Travel Date: minimum 15 calendar days from today.
// Rule 2 — Appointment Date: minimum 2 calendar days from today.
// All calculations are derived from the current date at runtime (never hard-coded).

export const MIN_TRAVEL_DAYS = 15;
export const MIN_APPOINTMENT_DAYS = 2;

export const TRAVEL_DATE_HINT =
  'Please select a travel date at least 15 days from today to allow sufficient time for visa processing.';
export const TRAVEL_DATE_ERROR =
  'Your intended travel date must be at least 15 days from today.';

export const APPOINTMENT_DATE_HINT =
  'Appointments must be booked at least 2 days in advance.';
export const APPOINTMENT_DATE_ERROR =
  'Please select an appointment date at least 2 days from today.';

// Format a Date as a local YYYY-MM-DD string (avoids UTC timezone off-by-one).
function toLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Today's local date as YYYY-MM-DD.
export function getTodayString(): string {
  return toLocalDateString(new Date());
}

// The local date exactly `days` calendar days from today as YYYY-MM-DD.
export function getDateFromToday(days: number): string {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + days);
  return toLocalDateString(date);
}

// First selectable Intended Travel Date (today + 15 days).
export function getMinTravelDate(): string {
  return getDateFromToday(MIN_TRAVEL_DAYS);
}

// First selectable Appointment Date (today + 2 days).
export function getMinAppointmentDate(): string {
  return getDateFromToday(MIN_APPOINTMENT_DAYS);
}

// Submission-level validation for the Intended Travel Date.
export function isTravelDateValid(value: string): boolean {
  if (!value) return false;
  return value >= getMinTravelDate();
}

// Submission-level validation for the Appointment Date.
export function isAppointmentDateValid(value: string): boolean {
  if (!value) return false;
  return value >= getMinAppointmentDate();
}